function FavoriteIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.4165 7.73239C19.5623 5.41691 23.156 5.42255 25.392 7.7493C27.536 10.0817 27.536 13.8338 25.392 16.0648L17.1181 24.6746C16.5279 25.2887 15.5473 25.2909 14.957 24.6767C12.6714 22.2983 7.4866 16.903 6.68106 16.0648C4.43965 13.8338 4.43965 10.0817 6.68106 7.7493C8.81995 5.42243 12.4137 5.41691 14.6562 7.73276C14.6616 7.73826 14.6669 7.74377 14.6722 7.7493L16.0365 9.16901L17.4009 7.7493C17.4061 7.74365 17.4113 7.73801 17.4165 7.73239Z"
				fill="#000000"
			></path>
		</svg>
	);
}

export default FavoriteIcon;
